import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IResult } from '../ServerApi/types/IResponse';
import { IUser } from '../ServerApi/types/IUser';
import { IUserActionResult, UserActionResultCode } from '../ServerApi/types/IUserActionResult';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { UserActionNotification, UserActionNotificationParams } from './UserActionNotification';

export interface ConfirmationBasedActionMetadata {
  dialogTitle: string;
  actionName: string;
  dialogBody: string;
  trigger: (userIds: string[]) => ng.IPromise<IUserActionResult>;
  actionSuccessCode: string;
}

export class ConfirmationBasedAction {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private userActionNotification: UserActionNotification,
    private actionMetadata: ConfirmationBasedActionMetadata) { }

  public runOn(context: IActionContext, users: Set<IUser>, isDeleteAction: boolean = false): ng.IPromise<IResult> {
    const dialogBody = this.$translate.instant(this.actionMetadata.dialogBody, {
      USER_NAME: L10n.elideIfLong(users.first().displayName),
      USER_COUNT: users.size()
    }, L10n.Interpolations.Count);

    const dialogInstance = this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant(this.actionMetadata.dialogTitle),
      bodyText: dialogBody,
      actionName: this.$translate.instant(this.actionMetadata.actionName, {
        ITEM_COUNT: users.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: isDeleteAction,
      action: () => this.actionMetadata.trigger(users.keys())
    });

    dialogInstance.result.then((result: IUserActionResult) => {
      const params: UserActionNotificationParams = {
        users: users,
        results: result.results,
        errors: result.errors,
        successCode: this.actionMetadata.actionSuccessCode,
      };
      this.userActionNotification.notify(params);
    });
    return dialogInstance.result;
  }
}
